import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Flex, Text, ButtonLink } from 'mdlkit';
import { useRouter } from 'next/router';
import { withLoginExperience } from '../../utils/authExperienceNavigation';
import { SIGN_IN_URL } from '../../constants/login';
import { REGISTRATION } from '../../constants/events';
import { event } from '../../lib/analytics';
import { dispatchSignInRequested } from '../../lib/mobile';

const StyledFlex = styled(Flex)`
  text-align: center;
`;

const StyledButtonLink = styled(ButtonLink)`
  &:focus {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #000000;
    outline: none;
    border-radius: 2px;
  }
`;

interface Props {
  signInLink?: string;
}

const SignInFooter: FunctionComponent<Props> = ({ signInLink }: Props) => {
  const { formatMessage: f } = useIntl();
  const router = useRouter();

  return (
    <StyledFlex pt="md" column align="center">
      <Text>
        <FormattedMessage id="register.alreadyHaveAccount" />
      </Text>
      <Text>
        <FormattedMessage id="register.addDependent" />
      </Text>
      <StyledButtonLink
        id="signInLink"
        onClick={(e) => {
          event({
            action: 'click_sign_in',
            category: REGISTRATION,
            label: 'location',
            value: 'register',
          });

          const mobileDetected = dispatchSignInRequested();
          if (mobileDetected) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          window.location.href = withLoginExperience(signInLink || '', router);
        }}
        data-track-event
        data-track={JSON.stringify({
          controlName:
            router.pathname === '/profile'
              ? 'sign-in-welcome-link'
              : 'sign-in-main-link',
          controlText: f({ id: 'signIn' }),
          destinationURL: signInLink,
        })}
      >
        <FormattedMessage id="signIn" />
      </StyledButtonLink>
    </StyledFlex>
  );
};

SignInFooter.defaultProps = {
  signInLink: SIGN_IN_URL,
};

export default SignInFooter;
